<template lang="html">
  <div class="locked">
    <p>This account has been flagged and locked. If you believe this is in error, please contact Suzan Luther at (269) 213-3904 or email <a href="mailto: suzan@bcamsc.org" target="_blank">suzan@bcamsc.org</a>.</p>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
p {
  border: 2px solid grey;
  border-radius: 5px;
  max-width: 50%;
  padding: 20px;
  margin: auto;
  margin-top:50px;
}
</style>
